import { AnoNe, CsEnNazev, CsEnPopis } from "b2b/renderers";

export const id = () => ({
  id: "id",
  label: "b2b.doplnkove-sluzby-grid.id.label",
  path: "id"
});
export const nazev = () => ({
  id: "nazev",
  label: "b2b.doplnkove-sluzby-grid.nazev.label",
  path: "",
  renderer: CsEnNazev
});
export const popis = () => ({
  id: "popis",
  label: "b2b.doplnkove-sluzby-grid.popis.label",
  path: "",
  renderer: CsEnPopis
});
export const zkratka = () => ({
  id: "zkratka",
  label: "b2b.doplnkove-sluzby-grid.zkratka.label",
  path: "zkratka"
});
export const uzivaNapajeni = () => ({
  id: "uzivaNapajeni",
  label: "b2b.doplnkove-sluzby-grid.uzivaNapajeni.label",
  path: "uzivaNapajeni",
  renderer: AnoNe
});
export const vylucny = () => ({
  id: "vylucny",
  label: "b2b.doplnkove-sluzby-grid.vylucny.label",
  path: "vylucny",
  renderer: AnoNe
});
